/**
 * @description SmartTag error codes
 */
export const TagErrorCode = {

	/**
	 * @description Unsupported browser
	 * @type {Number}
	 * @default 100
	 */
	UNSUPPORTED_BROWSER: '100',

	/**
	 * @description Dependency load failure
	 * @type {Number}
	 * @default 100
	 */
	DEPENDENCY_LOAD_FAILURE: '110',

	/**
	 * @description IMA load failure
	 * @type {Number}
	 * @default 101
	 */
	IMA_LOAD_FAILURE: '111',

	/**
	 * @description IMA load failed - Possible FF private mode
	 * @type {Number}
	 * @default 102
	 */
	IMA_LOAD_FAILURE_FF_PRIVATE_MODE: '112',

	/**
	 * @description Ad blocker cbs.com ANON user up-sell
	 * @type {Number}
	 * @default 103
	 */
	AD_BLOCKER_CBS_ANON_USER: '113',

	/**
	 * @description Ad blocker cbs.com LC user up-sell
	 * @type {Number}
	 * @default 104
	 */
	AD_BLOCKER_CBS_LC_USER: '114',

	/**
	 * @description Metadata load error - from page
	 * @type {Number}
	 * @default 120
	 */
	METADATA_LOAD_ERROR_PAGE: '120',

	/**
	 * @description Metadata load error - from CAN service
	 * @type {Number}
	 * @default 121
	 */
	METADATA_LOAD_ERROR_CAN: '121',

	/**
	 * @description Metadata: Service not allowed
	 * @type {Number}
	 * @default 122
	 */
	METADATA_SERVICE_NOT_ALLOWED: '122',

	/**
	 * @description Metadata: no encode found
	 * @type {Number}
	 * @default 123
	 */
	NO_ENCODE_FOUND: '123',

	/**
	 * @description MPX call: non 2xx call (i.e. 404)
	 * @type {Number}
	 * @default 124
	 */
	MPX_CALL_FAILURE: '124',

	/**
	 * @description MPX call: API returned invalid XML data
	 * @type {Number}
	 * @default 125
	 */
	MPX_DATA_INVALID: '125',

	/**
	 * @description RCO undefined
	 * @type {Number}
	 * @default 200
	 */
	RCO_UNDEFINED: '200',

	/**
	 * @description Container not found during Tag initialization
	 * @type {Number}
	 * @default 130
	 */
	CONTAINER_NOT_FOUND: '130',

	/**
	 * @description Tag initialization failure
	 * @type {Number}
	 * @default 131
	 */
	INITIALIZATION_FAILURE: '131',

	/**
	 * @description tag.API.VIDEO.load() blocked — no usable JWT for a Stitcher load (PLBCK-8587)
	 * @type {Number}
	 * @default 132
	 */
	MISSING_JWT_TOKEN: '132'

};